import React, { useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';

import './../styles/color-swatches.css'

import ColorSwatch from './color-swatch';

function ColorSwatches({
  title,
  showSelectedColor,
  showColorName,
  className,
  colors,
  selectedColor,
  setSelectedColor
}) {
  return (
    <section className={`${className ? className : ''} swatches-wrapper`}>
      {title && (
        <Grid container className="swatches-title-container">
          <h2 className="swatches-title">{title}</h2>
        </Grid>
      )}
      {showSelectedColor && (
        <Grid container className="swatches-selected-color-title-container">
          <p className="swatches-selected-color-title">
            <span>Color: </span>{selectedColor?.name}
          </p>
        </Grid>
      )}
      <Grid container alignItems="start" className="swatches-container">
        {colors.map((color) => {
          const isSelected = selectedColor.color === color.color;

          return (
            <ColorSwatch
              key={color.color}
              color={color}
              isSelected={isSelected}
              showColorName={showColorName}
              setSelectedColor={setSelectedColor}
            />
          );
        })}
      </Grid>
    </section>
  )
}

export default ColorSwatches
